// extracted by mini-css-extract-plugin
export default {"ProductsList":"ProductList_ProductsList__1FM0r"};